import numbro from "numbro";
import * as zhCN from "numbro/languages/zh-CN";
import { Config } from "../config";

numbro.registerLanguage(zhCN, true);

/**
 * 金额格式化, 2 位小数
 * @param m
 * @returns {string}
 */
export const formatCurrency = m => numbro(m).formatCurrency({
  mantissa: 2,
  thousandSeparated: true
});

/**
 * 单价格式化, 4 位小数
 * @param p
 * @returns {string}
 */
export const formatPrice = p => numbro(p).formatCurrency({
  mantissa: Config.pricePrecision,
  thousandSeparated: true
});

/**
 * 用量格式化, 无小数
 * @param u
 * @returns {string}
 */
export const formatUsage = u => numbro(u).format({
  mantissa: 0,
  thousandSeparated: true
});

/**
 * 用量格式化, 2 位小数
 * @param u
 * @returns {string}
 */
export const formatUsage2 = u => numbro(u).format({
  mantissa: 2,
  thousandSeparated: true
});

/**
 * 百分位格式化, 2 位小数
 * @param pe
 * @returns {string}
 */
export const formatPercent2 = pe => numbro(pe).format({
  mantissa: 2,
  output: "percent" ,
  thousandSeparated: true
});
